import styled from 'styled-components';

export const Grid = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(28rem, 1fr));
  grid-column-gap: 3rem;
  grid-row-gap: 3rem;
`;

export const Q = styled.div``;
